import React, { useEffect }  from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {  fetchProductsStart } from './../redux/Products/products.actions';
import {Link} from 'react-router-dom'
import {Container} from 'react-bootstrap'


const mapState = (state) => ({
	products: state.productsData.products,
	
});

const Plans = () =>{
	const { products } = useSelector(mapState);
	const dispatch = useDispatch();

	const { data } = products;

	useEffect(() => {
		window.scrollTo(0, 0)

		dispatch(
			fetchProductsStart()
		  );
		// eslint-disable-next-line
	}, [])


	const addonsArray = [];
	if(Array.isArray(data)){
	  for(let i = 0; i < data.length; i++){
		if(data[i].productCategory === "Add-ons"){
		  addonsArray.push(data[i]);
		}
	}}

	const vendorServicesArray = [];
	if(Array.isArray(data)){
	  for(let i = 0; i < data.length; i++){
		if(data[i].productCategory === "Vendor Service"){
			vendorServicesArray.push(data[i]);
		}
	}}

	const vendorPayPerServiceArray = [];
	if(Array.isArray(data)){
	  for(let i = 0; i < data.length; i++){
		if(data[i].productCategory === "Vendor Pay-Per Service"){
			vendorPayPerServiceArray.push(data[i]);
		}
	}}



	return (
		<div className="main">
			<section className="text-center">
				<Container>
					<h2 className="mb-5">The only home maintenance management subscription service.</h2>
				
					<div className="row equal py-3 pb-5 plans ">

							<div className="col-md-6 col-lg-4 my-3 d-flex justify-content-center">
								<div className="card card-block">
									
									<div className="card-header text-white py-4">
										<h3>Subscription</h3>
									</div>
									<div className="card-title my-3">
										<h4 className="bold">
											<sup>$</sup>129.99
											<sub>/month</sub>
										</h4>
									</div>
									<div className="card-body flex-fill">


										<ul className="list-group list-group-flush">
											{
												vendorServicesArray.map((product, index) => {
													const {
														productName,
														productDesc
													} = product;
													return (
														<li className="list-group-item planDetail" key={index}>{productName}

														 {productDesc &&(
															<span className="tooltiptext">{productDesc}</span>
														 	)

														 }
														</li>
													)
												})
											}
										</ul>

									</div>
									<Link to="/registration">
										<div className="card-footer">
											SIGN UP NOW!
										</div>
									</Link>
								</div>
							</div>
							<div className="col-md-6 col-lg-4 my-3 d-flex justify-content-center">
								<div className="card card-block">
									<div className="card-header text-white py-4">
										<h3>Additional Services</h3>
									</div>
									<div className="card-title my-3">
										<h4 className="bold">
											Fixed price add ons:
										</h4>
									</div>
									<div className="card-body flex-fill">
										<ul className="list-group list-group-flush">
											{
												addonsArray.map((product, index) => {
													const {
														productName,
														productDesc
													} = product;
													return (
														<li className="list-group-item planDetail" key={index}>{productName}

														 {productDesc &&(
															<span className="tooltiptext">{productDesc}</span>
														 	)
															 
														 }
														</li>
													)
												})
											}
										</ul>
									</div>
									<Link to="/registration">
										<div className="card-footer">
											SIGN UP NOW!
										</div>
									</Link>
								</div>
							</div>
							<div className="col-md-6 col-lg-4 my-3 d-flex justify-content-center">
								<div className="card card-block">
									<div className="card-header text-white py-4">
										<h3>Pay Per Use</h3>
									</div>
									<div className="card-title my-3">
										<h4 className="bold">
											Get a quote for a custom< br></br> home need:
										</h4>
									</div>
									<div className="card-body flex-fill">
										<ul className="list-group list-group-flush">
										{
												vendorPayPerServiceArray.map((product, index) => {
													const {
														productName,
														productDesc
													} = product;
													return (
														<li className="list-group-item planDetail" key={index}>{productName}

														 {productDesc &&(
															<span className="tooltiptext">{productDesc}</span>
														 	)
															 
														 }
														</li>
													)
												})
											}
										</ul>
									</div>
									<Link to="/registration">
										<div className="card-footer">
											SIGN UP NOW!
										</div>
									</Link>
								</div>
							</div>
					</div>
					<h2 className="mb-5">
						Say goodbye to your home owner responsibilities!
					</h2>
					

				</Container>
			</section>
		</div>
	)
}

export default Plans
